import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="Retour en haut"
      data-testid="back-to-top"
      className={`fixed bottom-6 right-6 z-[70] w-12 h-12 flex items-center justify-center atelier-border bg-atelier-deep/80 backdrop-blur-md text-atelier-ink hover:bg-atelier-ink hover:text-atelier-deep transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <ArrowUp className="w-4 h-4" strokeWidth={1.6} />
    </button>
  );
}
